import React, { PureComponent } from "react";

import Select from "react-select";

import { Button, ButtonGroup, Dropdown, Icon } from "aible";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";

import DashboardChart from "components/Next/Charts/DashboardChart";
import MuscleBarChart from "components/Next/Charts/MuscleBarChart";

import NextSearchContainer from "containers/Next/NextSearch";
import DashboardContainer from "containers/Next/Dashboard/Dashboard";

import ComparisonDashboard from "components/Next/Dashboard/ComparisonDashboard";

import AssignTodoModalContainer from "containers/Market/Jobs/AssignTodoModal";

import { rgb } from "d3-color";

export default class DashboardHolder extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      tempDatasetId: undefined
    };
  }

  render() {
    const { id, datasetId, datasets, initNextDashboard, tempDatasetId, comparisonOptions } = this.props;

    const retDatasetId = tempDatasetId !== undefined ? tempDatasetId : datasetId;

    if (comparisonOptions?.dateField) {
      return (
        <ComparisonDashboard
          originalId={id}
          datasetId={retDatasetId}
          id={tempDatasetId !== undefined && tempDatasetId !== datasetId ? "temp_" + tempDatasetId : id}
        />
      );
    }

    return (
      <DashboardContainer
        originalId={id}
        datasetId={retDatasetId}
        id={tempDatasetId !== undefined && tempDatasetId !== datasetId ? "temp_" + tempDatasetId : id}
      />
    );
  }
}
